// src/screens/Admin/FeedbackDetail.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../api';
import './FeedbackDetail.css';

import backIcon from '../../assets/backspace-icon.png';

function FeedbackDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await api.get(`/feedback/${id}`);
        setFeedback(res.data);
      } catch (err) {
        console.error('❌ Failed to fetch feedback detail:', err);
      }
    };

    fetchDetail();
  }, [id]);

  if (!feedback) {
    return <div className="feedback-detail-loading">Loading...</div>;
  }

  return (
    <div className="feedback-detail-wrapper">
      <div className="feedback-detail-header">
        <img src={backIcon} onClick={() => navigate(-1)} alt="back" />
        <h2>Feedback Detail</h2>
      </div>

      <div className="feedback-detail-scroll">
        <div className="feedback-detail-meta">
          <p><strong>From:</strong> {feedback.username}</p>
          <p><strong>Type:</strong> {feedback.type}</p>
          <p><strong>Date:</strong> {new Date(feedback.createdAt).toLocaleString()}</p>
        </div>

<div className="feedback-detail-description">
  <p>{feedback.text}</p>  
</div>


        <div className="feedback-detail-media">
          {feedback.media.map((url, i) => (
            url.endsWith('.mp4') || url.includes('video')
              ? <video key={i} src={url} controls />
              : <img key={i} src={url} alt={`media-${i}`} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default FeedbackDetail;
